/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_WEBDASHBOARD_DATA, WEBDASHBOARD_DATA_RECEIVED } = constants.webDashboardConstants;

export default {
    REQUEST_WEBDASHBOARD_DATA,
    WEBDASHBOARD_DATA_RECEIVED,

  requestInviteeData: payload => ({
    type: REQUEST_WEBDASHBOARD_DATA,
    payload
  }),
  inviteeDataReceived: () => ({
    type: WEBDASHBOARD_DATA_RECEIVED
  }),
};
